import { getAnswer, postAnswer } from '@/api/api';

export default {
  data() {
    return {
      finished: false,
      loading: false,
      answers: [],
    };
  },
  computed: {
    stepType() {
      if (this.$route.name === 'guided-lesson') {
        return 'TEACH_EXERCISE';
      }
      return 'GRAMMAR_EXERCISE';
    },
  },
  methods: {
    onReset() {
      this.answers = this.questions.map(question => ({
        content: '',
        question: question.uuid,
        student: this.student.email,
      }));
      this.finished = false;
      this.$emit('reset');
    },
    async onFinish() {
      if (!this.finished) {
        this.loading = true;
        for (let index = 0; index < this.answers.length; index++) {
          const element = this.answers[index];
          const response = await postAnswer(element);
          if (response) {
            this.answers.splice(index, 1, response.data);
          }
        }

        this.finished = true;
        this.loading = false;
      }
      this.$emit('finished');
    },
    async create() {
      this.answers = [];

      this.loading = true;

      for (let index = 0; index < this.questions.length; index++) {
        const element = this.questions[index];
        const response = await getAnswer({
          question__uuid: element.uuid,
          student__email: this.student.email,
        });

        if (response && response.data.count) {
          this.answers.push(response.data.results[0]);
        } else
          this.answers.push({
            question: element.uuid,
            student: this.student.email,
            content: '',
          });
      }

      if (this.answers[0] && this.answers[0].uuid) {
        this.finished = true;
        this.$emit('already-finished');
      }
      if (this.extraCreate) this.extraCreate();
      this.loading = false;
    },
  },
  async created() {
    this.create();
  },
  watch: {
    questions() {
      this.create();
    },
  },
};
